import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {AddUserNotes, GetNewUserList, UpdateUserNotes} from '../../UserListSlice/UserListSlice'
import {ProfileDetailData} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'

const AddNotesModel = ({
  show,
  handleClose,
  selectedNote,
  userList = false,
  selectedNoteUserId,
}: any) => {
  const dispatch = useDispatch()
  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const [note, setNote] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (selectedNote?.notes && show) {
      setNote(selectedNote?.notes)
    }
  }, [show])

  const handleCreate = () => {
    if (!note) {
      setError('please enter note')
    } else {
      if (selectedNote?._id) {
        dispatch(
          UpdateUserNotes({
            _id: selectedNote?._id,
            data: {notes: note, user: ProfileDetatileState?._id},
          })
        ).then(() => {
          dispatch(ProfileDetailData(ProfileDetatileState?._id || selectedNoteUserId))
          if (userList) dispatch(GetNewUserList())
        })
      } else {
        dispatch(AddUserNotes({notes: note, user: ProfileDetatileState?._id || selectedNoteUserId })).then(() => {
          dispatch(ProfileDetailData(ProfileDetatileState?._id || selectedNoteUserId))
          if (userList) dispatch(GetNewUserList())
        })
      }
      handleClose()
      setNote('')
    }
  }

  const handleCloseWithClear = () => {
    setNote('')
    setError('')
    handleClose()
  }

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-550px'
        className='vh-100'
        show={show}
        onHide={handleCloseWithClear}
      >
        <>
          <div className='modal-header'>
            <h1>{selectedNote?._id ? 'Edit' : 'Create'} new note</h1>
          </div>
          <div className='modal-body'>
            <label className='w-100'>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Note
              </span>
              <input
                placeholder='Enter Note'
                className='form-control form-control-solid border-0 w-100 mt-2'
                value={note}
                onChange={(e: any) => {
                  setError('')
                  setNote(e.target.value)
                }}
              />
              <span className='text-danger mt-1'>{error}</span>
              <span
                style={{
                  color: '#a1a5b7',
                  fontSize: '12px',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              ></span>
            </label>
          </div>
          <div className='modal-footer w-100'>
            <button onClick={handleCloseWithClear} type='button' className='btn btn-light-primary'>
              Cancel
            </button>
            <button
              disabled={error !== '' || note == ''}
              onClick={handleCreate}
              id='submit'
              type='button'
              className='btn btn-primary w-50 '
            >
              {selectedNote?._id ? 'Edit' : 'Create'} note
            </button>
          </div>
        </>
      </Modal>
    </>
  )
}

export default AddNotesModel
